import React, { useMemo } from 'react';

import usePage from '@dashboard/hooks/usePage';
import { SubmissionsList } from '@dashboard/scenes/Submissions';

const DEFAULT_SORT = { createdAt: '-1' };

function RecentSubmissions() {
  const { page } = usePage();

  const filter = useMemo(
    () => ({
      page: page._id,
      livemode: true,
    }),
    [page._id],
  );

  return (
    <div className="overflow-auto mb-20">
      <SubmissionsList
        sort={DEFAULT_SORT}
        filter={filter}
        options={{
          hidePaymentLink: true,
          hidePageType: true,
          hidePageName: true,
        }}
        infinite={false}
      />
    </div>
  );
}

export default RecentSubmissions;
